<script setup>
import { ref } from 'vue'
import { useDraggable } from '@vueuse/core'
const props = defineProps(['position','viewportid'])

const el = ref(null)

const { x, y, style } = useDraggable(el, {
  initialValue: { x: props.position.x || 0, y: props.position.y || 0 }, onEnd : onDragEnd,
})

function onDragEnd() {
  console.log('Got event on Drag end',x,y);
  if(x.value < 0) {
      x.value = 0;
  }
  if(y.value < 0) {
      y.value = 0;
  }
  const dragend = new Event('viewportOnDragEnd');
  window.dispatchEvent(dragend);
  //console.log('onDragEnd','calling on:', props.viewportid);
  //window.oxygenUtil.generateViewportEvent('viewportClicked', props.viewportid);
}

function setPosition(left, top) {
  if(left >= 0) {
    x.value = left;
  }
  if(top >= 0) {
    y.value = top;
  }
}

defineExpose({
  setPosition
});

</script>

<template>
  <div :style="style" style="position: fixed;">
    <div style="height: auto; background: transparent; color: white;margin-left:-5px;">
      <slot name="fullheader"></slot>
    </div>
    <div ref="el" style="height: auto; background: white; color: white;">
      <slot name="header"></slot>
    </div>
    <div style="background: white;display: '';">
        <slot name="communicationRibbon"></slot>
    </div>
    <div style="background: white;">
        <slot name="behaviour"></slot>
    </div>
    <div style="background: white;">
      <slot name="body"></slot>
    </div>
    <div style="height: auto; background: transparent; color: white;">
      <slot name="footer"></slot>
    </div>
  </div>
</template>
